/* eslint-disable */
import { DeleteOutlined } from '@ant-design/icons';
import {
  Button, Card, Col, Modal, Row,
  Space,
  Switch, Typography
} from 'antd';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { RequestStaffForm } from './Step3';

import Input from 'components/atoms/Input';
import { DropdownBanks } from 'components/organisms/DropdownBanks';
import { DropdownBranch } from 'components/organisms/DropdownBranch';
import { DropdownCity } from 'components/organisms/DropdownCity';
import { useQuery } from "react-query";
import { getAllBankService } from "services/banks";

type BanksProps = {
  positionBank: number,
  method: UseFormReturn<RequestStaffForm>,
  remove: (index: number) => void;
  view?: boolean;
  bankData?: Array<{
    accountDefault: boolean;
    accountName: string,
    accountNumber: string,
    bankCode?: string,
    bankId: number,
    bankName?: string,
    branchName?: string,
    isActive?: boolean,
    province?: {
      code: string;
      name: string;
    };
  }>
};

const Banks: React.FC<BanksProps> = ({
  positionBank,
  method,
  remove,
  view,
  bankData
}) => {
  const bankNameWatch = method.watch(`bankAccounts.${positionBank}.bankName`);
  const cityWatch = method.watch(`bankAccounts.${positionBank}.city`);
  const bankAccountsWatch = method.watch('bankAccounts');

  const isNotAgribank = (index: number) => !!(bankNameWatch?.value && !bankNameWatch?.value?.toString().toLowerCase().includes('agribank'));

  const bankAccountIdx = bankAccountsWatch.map((_, index) => index);
  const disabledBankField = (index: number) => isNotAgribank(index) && bankAccountIdx.includes(index);

  useQuery(
    ['get-bank-name-list', isNotAgribank(positionBank), bankNameWatch?.value],
    () => getAllBankService({
      page: 1,
      limit: 15,
      ...bankNameWatch?.value && { _name: bankNameWatch.value?.toString() },
    }),
    {
      enabled: isNotAgribank(positionBank),
      onSuccess: (res) => {
        if (res.data[0]?.bankData) {
          method.setValue(`bankAccounts.${positionBank}.bankId`, res.data[0].bankData.id);
        }
      }
    }
  );

  const onToggleDefault = (e: boolean, index: number) => {
    const isActive = method.getValues(`bankAccounts.${index}.isActive`);
    if (!isActive) method.setValue(`bankAccounts.${index}.isActive`, e);

    // Toggle off other bank accounts
    const accounts = method.getValues('bankAccounts');
    accounts.forEach((acc, idx) => {
      if (idx !== index && acc.isDefault) {
        method.setValue(`bankAccounts.${idx}.isDefault`, false);
      }
    });

    // Clear error after changed
    if (e && method.formState.errors.bankAccounts) {
      method.clearErrors('bankAccounts');
    }
  };

  const isViewBank = bankData?.find((bank) => positionBank <= bankData.length - 1 && bank.bankId === method.getValues(`bankAccounts.${positionBank}.bankId`));

  return (
    <Card
      className="u-mt-16"
      extra={(view || isViewBank) ? null : (
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              if (e.stopPropagation) e.stopPropagation();
              Modal.confirm({
                centered: true,
                className: 'p-home_deleteLanguageModal',
                autoFocusButton: 'cancel',
                okText: 'OK',
                cancelText: 'Hủy',
                cancelButtonProps: {
                  type: 'default',
                },
                okButtonProps: {
                  type: 'primary',
                },
                title: 'Đồng ý xoá bản ghi này?',
                onOk: () => remove(positionBank),
              });
            }}
            icon={<DeleteOutlined />}
          >
            Xoá
          </Button>
        </Space>
      )}
    >
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} className="u-mb-8">
          <Typography.Text strong>
            Tên
            {' '}
          </Typography.Text>
          <Typography.Text strong>
            {' '}
          </Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            name={`bankAccounts.${positionBank}.bankOwner`}
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <Input
                className="u-mt-8"
                name="name"
                placeholder="Tên"
                value={value}
                onChange={onChange}
                error={error?.message}
                size="large"
                disabled
              />
            )}
          />
        </Col>
        <Col xs={24} sm={12} md={8} className="u-mb-8">
          <Typography.Text strong>
            Số tài khoản
            {' '}
          </Typography.Text>
          <Typography.Text strong>
            {' '}
          </Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            name={`bankAccounts.${positionBank}.bankAccount`}
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <Input
                className="u-mt-8"
                name="name"
                placeholder="Số tài khoản"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value.toUpperCase());
                }}
                error={error?.message}
                size="large"
                disabled={view && !!(bankData && bankData[positionBank].accountNumber) || method.getValues(`bankAccounts.${positionBank}.isDisabled`)}
              />
            )}
          />
        </Col>
        <Col xs={12} sm={12} md={4} className="u-mb-8">
          <Typography.Text strong>
            Tài khoản mặc định
            {' '}
          </Typography.Text>
          <Typography.Text strong>
            {' '}
          </Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <div className="u-mt-8">
            <Controller
              control={method.control}
              name={`bankAccounts.${positionBank}.isDefault`}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <>
                  <Switch
                    checked={value}
                    onChange={(e) => {
                      onChange(e);
                      onToggleDefault(e, positionBank);
                    }}
                    disabled={view}
                  />
                  {error && (
                    <Typography.Text type="danger">
                      {error.message}
                    </Typography.Text>
                  )}
                </>
              )}
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={4} className="u-mb-8">
          <Typography.Text strong>
            Kích hoạt
            {' '}
          </Typography.Text>
          <Typography.Text strong>
            {' '}
          </Typography.Text>
          <div className="u-mt-8">
            <Controller
              name={`bankAccounts.${positionBank}.isActive`}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <>
                  <Switch
                    disabled
                    checked={value}
                    onChange={onChange}
                  />
                  {error && (
                    <Typography.Text type="danger">
                      {error.message}
                    </Typography.Text>
                  )}
                </>
              )}
            />
          </div>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} className="u-mb-8">
          <Typography.Text strong>
            Tên ngân hàng
            {' '}
          </Typography.Text>
          <Typography.Text strong type="danger">
            *
          </Typography.Text>
          <Controller
            name={`bankAccounts.${positionBank}.bankName`}
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <DropdownBanks
                name="branch"
                placeholder="Tên ngân hàng"
                isGetOption
                value={value}
                isShowSearch
                error={error?.message}
                onChange={(val) => {
                  onChange(val);
                  method.setValue(`bankAccounts.${positionBank}.bankId`, val ? val.value : null);
                  method.setValue(`bankAccounts.${positionBank}.city`, null);
                  method.setValue(`bankAccounts.${positionBank}.bankBranch`, null);
                }}
                size="large"
                disabled={view && !!(bankData && bankData[positionBank].bankName) || method.getValues(`bankAccounts.${positionBank}.isDisabled`)}
                enabled
              />
            )}
          />
        </Col>
        <Col xs={24} sm={12} md={8} className="u-mb-8">
          <Typography.Text strong>
            Tỉnh/Thành phố
            {' '}
          </Typography.Text>
          {disabledBankField(positionBank) ? null : (
            <Typography.Text strong type="danger">
              *
            </Typography.Text>
          )}
          <Controller
            name={`bankAccounts.${positionBank}.city`}
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <DropdownCity
                placeholder="Tỉnh/Thành phố"
                isGetOption
                value={value}
                error={error?.message}
                disabled={isNotAgribank(positionBank) || !!(view && !!(bankData && bankData[positionBank].bankName)) || method.getValues(`bankAccounts.${positionBank}.isDisabled`)}
                isShowSearch={false}
                onChange={(val) => {
                  onChange(val);
                  method.setValue(`bankAccounts.${positionBank}.bankBranch`, null);
                }}
                size="large"
                bankNameWatch={bankNameWatch}
                enableQuery={!!bankNameWatch?.label && !isNotAgribank(positionBank)}
              />
            )}
          />
        </Col>
        <Col xs={24} sm={12} md={8} className="u-mb-8">
          <Typography.Text strong>
            Chi nhánh
            {' '}
          </Typography.Text>
          {disabledBankField(positionBank) ? null : (
            <Typography.Text strong type="danger">
              *
            </Typography.Text>
          )}
          <Controller
            name={`bankAccounts.${positionBank}.bankBranch`}
            control={method.control}
            render={({
              field: { value, onChange },
              fieldState: { error },
            }) => (
              <DropdownBranch
                placeholder="Chi nhánh"
                isGetOption
                value={value}
                isShowSearch={false}
                error={error?.message}
                disabled={isNotAgribank(positionBank) || !!(view && !!(bankData && bankData[positionBank].bankName)) || method.getValues(`bankAccounts.${positionBank}.isDisabled`)}
                onChange={(val) => {
                  onChange(val);
                  if (val?.value) method.setValue(`bankAccounts.${positionBank}.bankId`, val.value);
                }}
                size="large"
                bankNameWatch={bankNameWatch}
                province={cityWatch}
                enableQuery={!!(bankNameWatch && cityWatch)}
              />
            )}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default Banks;
